module.exports = {"510104017":"锦官驿街道","510104018":"东湖街道","510104019":"锦华路街道","510104022":"春熙路街道","510104023":"书院街街道","510104026":"牛市口街道","510104030":"沙河街道","510104032":"狮子山街道","510104035":"成龙路街道","510104036":"柳江街道","510104037":"三圣街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510104.json
// module id = 2382
// module chunks = 0